<!-- StepFinalReport.vue -->
<template>
  <div class="modal_final">
    <div class="modal_main_inputs_head">
      Ваш отчет готов!
    </div>
    
    <div class="modal_final_content">
      <!-- Левая колонка -->
      <div class="modal_final_left">
        <!-- Блок 1: Тип документа (статический) -->
        <div class="info-block">
          <div class="info-block-header">
            <div class="info-block-title">Тип документа</div>
            <div class="info-block-status">Регламент</div>
          </div>
          <div class="info-block-description">
            Документ успешно распознан как регламент
          </div>
        </div>

        <!-- Блок 2: Найденные разделы -->
        <div class="info-block" v-if="sections.length">
          <div class="info-block-title">Найденные разделы</div>
          <div class="sections-list">
            <div v-for="(section, index) in sections" :key="index" class="section-item">
              <span class="section-icon">
                <svg v-if="checklist[index + 1]" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 6L9 17L4 12" stroke="#00ff00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span v-else class="section-icon-false">✕</span>
              </span>
              <span class="section-name">{{ section }}</span>
            </div>
          </div>
        </div>

        <!-- Блок 3: Стоимость процесса -->
        <div class="info-block" v-if="hasEstimation">
          <div class="info-block-title">Стоимость процесса</div>
          <div class="cost-grid">
            <div class="cost-item">
              <div class="cost-label">Стоимость одной единицы</div>
              <div class="cost-value">{{ formatCost(estimation.cost_per_unit) }} ₽</div>
            </div>
            <div class="cost-item">
              <div class="cost-label">Годовой объем затрат</div>
              <div class="cost-value">{{ formatCost(estimation.cost_per_unit * (parseInt(quantity) || 0)) }} ₽</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Правая колонка -->
      <div class="modal_final_right">
        <!-- Блок 4: Продукт процесса -->
        <div class="info-block">
          <div class="info-block-title">Продукт процесса</div>
          <div class="product-info">
            <div class="product-name">{{ product }}</div>
            <div class="product-quantity">{{ quantity }} единиц в год</div>
          </div>
          <div class="product-note">
            Lazarus автоматически определил продукт на основе анализа регламента
          </div>
        </div>

        <!-- Блок 5: Сводка по ролям -->
        <div class="info-block" v-if="roles.length">
          <div class="info-block-title">Сводка по ролям</div>
          <div class="roles-list">
            <div v-for="(role, index) in roles" :key="index" class="role-item">
              <div class="role-name">{{ role.name }}</div>
              <div class="role-details">{{ role.count }} чел. × {{ formatCost(role.cost) }} ₽/час</div>
            </div>
          </div>
        </div>

        <!-- Блок с ценой отчета -->
        <div class="price-block">
          <div class="price-header">
            <div class="price-title">Стоимость отчета</div>
            <div class="price-value">{{ price }}</div>
            <div class="price-description">{{ priceDescription }}</div>
          </div>
          <div class="price-features">
            <div v-for="(item, index) in finalItems" :key="index" class="price-feature">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#8A75FF" stroke-width="2">
                <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>{{ item }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
        <!-- Блок с email и скачиванием -->
    <div class="download-section">
      <div class="download-title">Укажите email для получения отчета</div>
      
      <!-- Показываем форму только если нет ссылки -->
      <template v-if="!reportUrl">
        <div class="download-form">
          <input 
            type="email" 
            v-model="email" 
            @input="validateEmail"
            placeholder="Введите ваш email"
            class="email-input"
            :class="{ 'invalid': !isEmailValid && email !== '' }"
          />
          
          <div class="modal_main_load_content_btn download-btn" 
     @click.prevent.stop="handleDownload"
     :class="{ 'disabled': !isEmailValid || isDownloading }"
     style="cursor: pointer;">
     
            <span v-if="isDownloading">Отправка...</span>
            <span v-else>Получить ссылку</span>
          </div>
        </div>
        <div v-if="emailError" class="error-message">{{ emailError }}</div>
      </template>
      
      <!-- Показываем кнопку-ссылку когда ссылка получена -->
      <div v-else class="download-result">
        <a :href="reportUrl" target="_blank" class="modal_main_load_content_btn download-btn success">
          Скачать отчет
        </a>
      </div>
    </div>
        <!-- Кнопки действий -->
        <div class="modal_final_actions">
      <div class="modal_main_load_content_btn restart-btn" @click="$emit('restart')">
        <span>Начать сначала</span>
      </div>
    </div>
    <div class="modal_final_actions">
      <a :href="'https://t.me/Lazarusai_bot?start=' + taskId" target="_blank" class="modal_main_load_content_btn restart-btn" style="align-items: center;">
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M18.7945 6.53461C19.3876 6.31941 19.682 6.24196 19.8451 6.21426C19.8463 6.26641 19.8451 6.30869 19.8424 6.33643C19.6098 8.78035 18.5908 14.793 18.0674 17.5908C17.9449 18.246 17.8509 18.5579 17.2181 18.1862C16.8016 17.9414 16.4247 17.6334 16.0209 17.3687C14.6963 16.5003 12.8002 15.2071 12.9559 15.2849C11.6518 14.4255 12.1977 13.8993 12.9257 13.1975C13.0436 13.0839 13.1662 12.9657 13.2865 12.8407C13.3402 12.7849 13.6029 12.5406 13.9733 12.1963C15.1614 11.0917 17.4573 8.95721 17.5153 8.7102C17.5248 8.66968 17.5336 8.51863 17.4438 8.43886C17.3541 8.3591 17.2217 8.38638 17.1261 8.40807C16.9906 8.43882 14.8328 9.86509 10.6526 12.6868C10.0401 13.1074 9.48536 13.3124 8.9883 13.3016L8.99275 13.3038C8.338 13.0729 7.68509 12.8741 7.02874 12.6742C6.59755 12.5428 6.16488 12.411 5.72923 12.2694C5.62268 12.2348 5.51872 12.2019 5.42102 12.1712C9.948 10.1991 12.9632 8.90061 14.4741 8.27218C16.6686 7.35942 17.9703 6.83369 18.7945 6.53461ZM21.2171 4.60624C20.9637 4.40062 20.6852 4.30625 20.4917 4.26003C20.2919 4.2123 20.102 4.19694 19.958 4.19948C19.4816 4.20787 18.9699 4.34336 18.1123 4.65455C17.2375 4.972 15.8932 5.51581 13.706 6.42554C12.164 7.06692 9.09407 8.38934 4.50384 10.3892C4.10065 10.5504 3.73105 10.7333 3.43903 10.9501C3.16938 11.1504 2.79192 11.5087 2.72287 12.0596C2.67071 12.4756 2.79201 12.8596 3.03801 13.162C3.25217 13.4252 3.52654 13.5851 3.73548 13.6863C4.04564 13.8365 4.46295 13.9673 4.82971 14.0823C5.40283 14.2619 5.97463 14.4454 6.54898 14.6212C8.3271 15.1655 9.79085 15.6135 11.4014 16.6748C12.5827 17.4533 13.7412 18.2657 14.9245 19.0413C15.3561 19.3242 15.7595 19.6489 16.2051 19.9106C16.6918 20.1966 17.3106 20.4574 18.0638 20.388C19.2021 20.2833 19.7943 19.2361 20.0333 17.9585C20.5554 15.1678 21.5911 9.07169 21.8334 6.52592C21.865 6.19362 21.828 5.82118 21.7972 5.64136C21.7655 5.45618 21.6686 4.97266 21.2171 4.60624Z"
            fill="white" />
        </svg>
        <span>Получить с подарком в Telegram</span>
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M15.5049 2.00195C17.714 2.00195 19.5049 3.79281 19.5049 6.00195C19.5049 6.73098 19.3098 7.41446 18.9691 8.00306L23.5049 8.00195V10.0019H21.5049V20.0019C21.5049 20.5542 21.0572 21.0019 20.5049 21.0019H4.50488C3.9526 21.0019 3.50488 20.5542 3.50488 20.0019V10.0019H1.50488V8.00195L6.04065 8.00306C5.69992 7.41446 5.50488 6.73098 5.50488 6.00195C5.50488 3.79281 7.29574 2.00195 9.50488 2.00195C10.7001 2.00195 11.7729 2.52616 12.5058 3.35721C13.2369 2.52616 14.3097 2.00195 15.5049 2.00195ZM11.5049 10.0019H5.50488V19.0019H11.5049V10.0019ZM19.5049 10.0019H13.5049V19.0019H19.5049V10.0019ZM9.50488 4.00195C8.40031 4.00195 7.50488 4.89738 7.50488 6.00195C7.50488 7.05631 8.32076 7.92011 9.35562 7.99646L9.50488 8.00195H11.5049V6.00195C11.5049 5.0003 10.7686 4.17064 9.80766 4.02472L9.65415 4.00743L9.50488 4.00195ZM15.5049 4.00195C14.4505 4.00195 13.5867 4.81783 13.5104 5.85269L13.5049 6.00195V8.00195H15.5049C16.5592 8.00195 17.423 7.18607 17.4994 6.15121L17.5049 6.00195C17.5049 4.89738 16.6095 4.00195 15.5049 4.00195Z"
            fill="white" />
        </svg>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepFinalReport',
  props: {
    taskId: {
      type: String,
      default: ''
    },
    sections: {
      type: Array,
      default: () => []
    },
    checklist: {
      type: Object,
      default: () => ({})
    },
    estimation: {
      type: Object,
      default: () => ({
        cost_per_unit: 0,
        time_per_unit_hours: 0,
        total_roles_involved: 0,
        total_annual_cost: 0
      })
    },
    hasEstimation: {
      type: Boolean,
      default: false
    },
    product: {
      type: String,
      default: ''
    },
    quantity: {
      type: [String, Number],
      default: '0'
    },
    roles: {
      type: Array,
      default: () => []
    },
    finalItems: {
      type: Array,
      default: () => [
        'Полный аудит регламента',
        'Анализ структуры документа',
        'Расчет стоимости процесса',
        'Рекомендации по улучшению'
      ]
    },
    price: {
      type: String,
      default: 'Free'
    },
    priceDescription: {
      type: String,
      default: ''
    }
  },
  emits: ['restart', 'download', 'share', 'save'],
  data() {
    return {
      email: '',
      isEmailValid: false,
      isDownloading: false,
      emailError: '',
      reportUrl: null
    }
  },
  methods: {
    formatCost(value) {
      const num = parseInt(value) || 0
      return new Intl.NumberFormat('ru-RU').format(num)
    },
    
    validateEmail() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      this.isEmailValid = emailRegex.test(this.email)
      this.emailError = ''
    },
    
    async handleDownload(event) {
  // Жестко запрещаем всё
  if (event) {
    event.preventDefault()
    event.stopPropagation()
  }
  
  // Принудительно оставляем скролл на месте
  const scrollX = window.scrollX
  const scrollY = window.scrollY
  
  if (this.reportUrl) {
    return
  }
  
  if (!this.isEmailValid || this.isDownloading || !this.taskId) return
  
  this.isDownloading = true
  this.emailError = ''
  
  try {
    const contactResponse = await fetch(`${this.$parent?.ApiLink || ''}/api/v1/tasks/contacts`, {
      method: 'POST',
      headers: {
        'accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        task_id: this.taskId,
        email: this.email,
        tg_id: "",
        username: "",
        first_name: "",
        last_name: ""
      })
    })
    
    if (!contactResponse.ok) {
      throw new Error('Ошибка при отправке email')
    }
    
    // Задержка 5 секунд для второго сценария
    if (this.$options.name === 'StepComparisonFinalReport') {
      await new Promise(resolve => setTimeout(resolve, 5000))
    }
    
    this.reportUrl = `${this.$parent?.ApiLink || ''}/api/v1/tasks/${this.taskId}/report`

    
    // Возвращаем скролл на место

    
  } catch (error) {
    console.error('Ошибка:', error)
    this.emailError = 'Не удалось получить ссылку. Попробуйте позже.'
  } finally {
    this.isDownloading = false
  }
},
  }
}
</script>

<style scoped>
.modal_main_inputs_head {
  text-align: start;
  margin-bottom: 24px;
  font-size: 24px;
  font-weight: 600;
}

.modal_final_content {
  display: flex;
  gap: 24px;
  width: 100%;
}

.modal_final_left,
.modal_final_right {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.info-block {
  background: #ffffff0a;
  border: 1px solid #403F6D;
  border-radius: 16px;
  padding: 20px;
}

.info-block-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.info-block-title {
  font-size: 16px;
  font-weight: 600;
  color: #8A75FF;
  margin-bottom: 16px;
  text-align: start;
}

.info-block-status {
  background: #00aa0020;
  color: #00ff00;
  border: 1px solid #00ff00;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 14px;
}

.info-block-description {
  color: #888;
  font-size: 14px;
  line-height: 1.5;
  text-align: start;
}

.sections-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.section-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.section-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.section-icon-false {
  color: #ff6b6b;
  font-size: 18px;
  font-weight: bold;
}

.section-name {
  color: #fff;
  font-size: 14px;
}

.cost-grid {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.cost-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #403F6D;
}

.cost-item:last-child {
  border-bottom: none;
}

.cost-label {
  color: #888;
  font-size: 14px;
}

.cost-value {
  color: #8A75FF;
  font-size: 18px;
  font-weight: 600;
}

.product-info {
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.product-name {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 4px;
  text-align: start;
}

.product-quantity {
  color: #888;
  font-size: 14px;
}

.product-note {
  color: #666;
  font-size: 12px;
  padding-top: 8px;
  border-top: 1px solid #403F6D;
}

.roles-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.role-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #403F6D;
}

.role-item:last-child {
  border-bottom: none;
}

.role-name {
  color: #fff;
  font-size: 14px;
  font-weight: 500;
}

.role-details {
  color: #8A75FF;
  font-size: 14px;
}

.price-block {
  background: #ffffff0a;
  border: 1px solid #403F6D;
  border-radius: 16px;
  overflow: hidden;
}

.price-header {
  background: #8A75FF20;
  padding: 20px;
  text-align: center;
  border-bottom: 1px solid #403F6D;
}

.price-title {
  color: #888;
  font-size: 14px;
  margin-bottom: 8px;
}

.price-value {
  color: #8A75FF;
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 4px;
}

.price-description {
  color: #8A75FF;
  font-size: 12px;
}

.price-features {
  padding: 20px;
}

.price-feature {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  color: #fff;
  font-size: 14px;
}

.price-feature svg {
  flex-shrink: 0;
}

.modal_final_actions {
  margin-top: 24px;
}

.modal_main_load_content_btn {
  display: flex;
  gap: 8px;
  padding: 18px 40px;
  background: #8A75FF;
  justify-content: center;
  border-radius: 24px;
  cursor: pointer;
  transition: opacity 0.3s;
  width: 100%;
}

.modal_main_load_content_btn:hover {
  opacity: 0.9;
}

.download-section {
  margin-top: 32px;
  padding: 24px;
  background: #ffffff0a;
  border: 1px solid #403F6D;
  border-radius: 16px;
}

.download-title {
  font-size: 18px;
  font-weight: 600;
  color: #8A75FF;
  margin-bottom: 16px;
  text-align: start;
}

.download-form {
  display: flex;
  gap: 16px;
  align-items: center;
}

.email-input {
  flex: 1;
  background: #ffffff0a;
  border: 1px solid #403F6D;
  border-radius: 12px;
  padding: 16px 20px;
  color: #fff;
  font-size: 16px;
  transition: all 0.3s;
}

.email-input:focus {
  outline: none;
  border-color: #8A75FF;
  background: #ffffff15;
}

.email-input.invalid {
  border-color: #ff6b6b;
}

.email-input::placeholder {
  color: #666;
}

.download-btn {
  width: auto;
  min-width: 200px;
  padding: 16px 32px;
}

.download-btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

.download-link {
  margin-top: 12px;
  text-align: start;
}

.report-link {
  color: #8A75FF;
  text-decoration: underline;
  font-size: 14px;
  cursor: pointer;
}

.report-link:hover {
  opacity: 0.8;
}

.error-message {
  color: #ff6b6b;
  font-size: 14px;
  margin-top: 8px;
  text-align: start;
}

@media (max-width: 1024px) {
  .modal_final_content {
    flex-direction: column;
  }
}

@media (max-width: 768px) {
  .download-form {
    flex-direction: column;
  }
  
  .download-btn {
    width: 100%;
  }
}

@media (max-width: 580px) {
  .cost-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
  
  .role-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
}
.download-result {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}

.download-btn.success {
  background: #00aa00;
  min-width: 200px;
  text-decoration: none;
  color: white;
  width: 100%;
}

.download-btn.success:hover {
  background: #00cc00;
}
</style>